import React from 'react';
import { ProductItemBySku, ProductStatus } from 'src/types/global-types';
import { Product } from 'src/components/SimpleProductList/Product';
import classnames from 'classnames';
import Slider from 'src/elements/Carousel/Slider';
import { productCarouselSettings } from 'src/elements/Carousel/settings';

import classes from './SimpleProductList.scss';

type Props = {
    products: ProductItemBySku[];
    display: 'flex' | 'grid' | 'carousel' | 'flexLeft';
    viewAll?: boolean;
    simpleProduct?: boolean;
    overflowHidden?: boolean;
};

export const SimpleProductList: React.FC<Props> = ({
    products,
    display,
    viewAll = false,
    simpleProduct = false,
    overflowHidden = false,
}) => (
    <div
        className={classnames(classes.container, {
            [classes.simpleProduct]: simpleProduct,
            [classes.overflowHidden]: overflowHidden,
        })}
    >
        {display === 'carousel' ? (
            <Slider {...productCarouselSettings}>
                {products
                    .filter((product) => product.status !== ProductStatus.disable)
                    .map((product) => (
                        <Product key={product.sku || product.urlKey} product={product} simpleProduct={simpleProduct} />
                    ))}
            </Slider>
        ) : (
            <div className={classnames(classes.products, classes[display])}>
                {products
                    .filter((product) => product.status !== ProductStatus.disable)
                    .map((product) => (
                        <Product key={product.sku || product.urlKey} product={product} simpleProduct={simpleProduct} />
                    ))}
            </div>
        )}

        {viewAll && (
            <div
                className={classnames(classes.button, {
                    [classes.leftAligned]: simpleProduct,
                })}
            >
                <a href="/t-shirts/all-t-shirts" className="button">
                    View all
                </a>
            </div>
        )}
    </div>
);
